import { call, put, takeLatest } from 'redux-saga/effects';
import constants from 'constants';
import actions from 'actions';

const {
  API_HOSPITALS,
  LOAD_HOSPITALS_SAGA,
  LOAD_COUNTIES_SAGA,
  API_COUNTIES,
  LOAD_SPONSORS_SUGGESTIONS_SAGA,
  API_SPONSORS
} = constants;

const {
  addHospitalSuggestions,
  addCountySuggestions,
  addRequestError,
  addSponsorSuggestions
} = actions;


const apiLoadHospitalsSaga = (q) => (
  axios.get(`${API_HOSPITALS}?title=${q}`)
)

const apiLoadCountiesSaga = (q) => (
  axios.get(`${API_COUNTIES}?title=${q}`)
)

const apiLoadSponsorsSaga = (q) => (
  axios.get(`${API_SPONSORS}?title=${q}`, {
    params: {
      page: 'all'
    }
  })
)

function* loadHospitals({ q }) {
  try {
    const response = yield call(apiLoadHospitalsSaga, q);
    const hospitals = response.data.hospitals;
    yield put(addHospitalSuggestions(q, hospitals));
  } catch (e) {
    yield put(addRequestError(e.response));
  }
}

function* loadCountiesSaga() {
  try {
    const response = yield call(apiLoadCountiesSaga);
    const counties = response.data.counties;
    const suggestCounties = Object.keys(counties).map(county => ({ value: county, label: county }))
    yield put(addCountySuggestions(suggestCounties));
  } catch (e) {
    console.log(e);
    yield put(addRequestError(e.response));
  }
}

function* loadSponsorsSaga({ q = '' }) {
  try {
    const response = yield call(apiLoadSponsorsSaga, q);
    const sponsors = response.data.sponsors;

    const suggestSponsors = sponsors.map(sponsor => ({
      value: sponsor.id,
      label: sponsor.title
    }));

    yield put(addSponsorSuggestions(suggestSponsors));
  } catch (e) {
    console.log(e);
    yield put(addRequestError(e.response));
  }
}

function* __loadHospitalsSaga() {
  yield takeLatest(LOAD_HOSPITALS_SAGA, loadHospitals)

}
function* __loadCountiesSaga() {
  yield takeLatest(LOAD_COUNTIES_SAGA, loadCountiesSaga)
}

function* __loadSponsorSuggestionsSaga() {
  yield takeLatest(LOAD_SPONSORS_SUGGESTIONS_SAGA, loadSponsorsSaga)
}

export {
  __loadHospitalsSaga,
  __loadCountiesSaga,
  __loadSponsorSuggestionsSaga
};




/** WEBPACK FOOTER **
 ** ./src/sagas/suggestions.js
 **/